export default "__VITE_ASSET__8I2uPlyQ__"